module.exports = __webpack_public_path__ + "img/facebook-share-icon.9ddd5138.svg";